<template>
    <div class="cst-survey-card-question">
        <h2 v-html="question.question"></h2>
        <component :is="answerType" :question="question"></component>
        <card-button-bar :question="question" :skippable="skippable"></card-button-bar>
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    import CardAnswerOption from './CardAnswerOption'
    import CardAnswerPercent from './CardAnswerPercent'
    import CardAnswerScale from './CardAnswerScale'
    import CardAnswerText from './CardAnswerText'
    import CardButtonBar from './CardButtonBar'

    export default {
      data: function () {
        return {
        }
      },
      props: ['content'],
      computed: {
        skippable: function () {
          return this.question.skippable()
        },
        answerType: function () {
          return 'card-answer-' + this.question.type
        },
        question: function () {
          return this.$store.state.decks[0].questions[this.content.id]
        }
      },
      created: function () {
        eventHub.$emit('set-title', this.question.group_title)
      },
      watch: {
        question: function (newQuestion, oldQuestion) {
          eventHub.$emit('set-title', newQuestion.group_title)
        }
      },
      components: {
        CardAnswerOption, CardAnswerScale, CardAnswerPercent, CardButtonBar, CardAnswerText
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    .cst-survey-card-question {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .cst-public-review-example {
      img {
        width: 100%;
      }
    }
</style>




// WEBPACK FOOTER //
// src/components/CardQuestion.vue